/* Landing VIBE 2026: dem nguoc, bat/tat khoi tu van rieng, cuon toi form sau khi gui */
(function () {
  'use strict';

  /* ---------- dem nguoc ---------- */
  var box = document.getElementById('vb-count');
  if (box) {
    var target = new Date(box.getAttribute('data-target')).getTime();
    var u = {};
    box.querySelectorAll('[data-u]').forEach(function (n) { u[n.getAttribute('data-u')] = n; });
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
    var timer;
    var tick = function () {
      var diff = target - Date.now();
      if (diff <= 0) {
        box.innerHTML = '<div class="vb-count__live">' + (box.getAttribute('data-live') || 'Triển lãm đang diễn ra') + '</div>';
        clearInterval(timer);
        return;
      }
      var s = Math.floor(diff / 1000);
      u.d.textContent = Math.floor(s / 86400);
      u.h.textContent = pad(Math.floor((s % 86400) / 3600));
      u.m.textContent = pad(Math.floor((s % 3600) / 60));
      u.s.textContent = pad(s % 60);
    };
    tick();
    timer = setInterval(tick, 1000);
  }

  /* ---------- khoi tu van rieng: an khi chua tick, tat input de khong gui kem ---------- */
  document.querySelectorAll('[data-vb-toggle]').forEach(function (cb) {
    var panel = document.getElementById(cb.getAttribute('data-vb-toggle'));
    if (!panel) return;
    var sync = function () {
      panel.hidden = !cb.checked;
      panel.querySelectorAll('input,select,textarea').forEach(function (f) { f.disabled = !cb.checked; });
    };
    cb.addEventListener('change', sync);
    sync();
  });

  /* ---------- sau khi gui form, dua khach ve dung vi tri form ---------- */
  if (/[?&](contact_posted|form_type)=/.test(location.search) || /#vb-dangky-form|#contact_form/.test(location.hash)) {
    var sec = document.getElementById('dang-ky');
    if (sec) requestAnimationFrame(function () { sec.scrollIntoView({ block: 'start' }); });
  }
})();
